import { useAccountStore } from '@/stores/account';
import { computed } from 'vue';

const { umami } = window;

// eslint-disable-next-line import/prefer-default-export
export function useAnalytics() {
  const CustomerId = computed(() => useAccountStore().CustomerId);
  const DistributorId = computed(() => useAccountStore().DistributorId);

  const track = (name, data = {}) => {
    if (!umami || !DistributorId.value) return;

    umami.track((props) => ({
      ...props,
      website: import.meta.env.VITE_UMAMI_SITE_ID,
      url: `/${DistributorId.value}`,
      name,
      data: {
        ...data,
        customerId: CustomerId.value,
      },
    }));
  };
  return {
    track,
  };
}
